import tagTester from './_tagTester.js';

export default tagTester('Date');



//////////////////
// WEBPACK FOOTER
// ./~/underscore/modules/isDate.js
// module id = 1330
// module chunks = 9